import VerticalSlider from "../../containers/VerticalSlider";

export const casinoGamesData = {
  indianCard: {
    SuperAndarBahar: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/ezg-andar-bahar",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/indian-card/SuperAndarBahar.jpg",
      alt: "Super Andar Bahar",
      name: "Super Andar Bahar",
      providerName: "Evolutio",
    },
    TeenPatti3Card: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/ezg-teen-patti-3-card",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/indian-card/TeenPatti.jpg",
      alt: "teen patti 3 card",
      name: "teen patti 3 card",
      providerName: "Ezugi",
    },
    BetOnTeenPatti: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/aggapjiligaming-teenpatti-20-20",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/indian-card/TeenPatti20-20.jpg",
      alt: "bet on teen patti",
      name: "bet on teen patti",
      providerName: "Ezugi",
    },
    AndarBahar: {
      code: "",
      casino: "JiliGaming",
      provider: "Ezugi",
      redirectUrl: "/casino/aggapjiligaming-andar-bahar-u6903",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/indian-card/AndarBahar.jpg",
      alt: "andar bahar",
      name: "andar bahar",
      providerName: "Ezugi",
    },
    Cards32: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/ezg-32-cards",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/indian-card/32Cards.jpg",
      alt: "32 cards",
      name: "32 cards",
      providerName: "Ezugi",
    },
    SpanishRoulette: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/ezg-spanish-roulette",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/indian-card/Roulette.jpg",
      alt: "spanish roulette",
      name: "spanish roulette",
      providerName: "Ezugi",
    },
    CricketWar: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/ezg-cricket-war",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/indian-card/Cricketwar.jpg",
      alt: "cricket war",
      name: "cricket war",
      providerName: "Ezugi",
    },
    SicBo: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/ezg-sic-bo",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/indian-card/Sicbo.jpg",
      alt: "sic bo",
      name: "sic bo",
      providerName: "Ezugi",
    },
    Baccarat: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/ezg-baccarat",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/indian-card/Baccarat.jpg",
      alt: "baccarat",
      name: "baccarat",
      providerName: "Ezugi",
    },
    DragonTiger: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/ezg-dragon-tiger",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/indian-card/DragonTiger.jpg",
      alt: "dragon tiger",
      name: "dragon tiger",
      providerName: "Ezugi",
    },
    OneDayTteenPatti: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/ezg-one-day-teen-patti",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/indian-card/OneDayTeenPatti.jpg",
      alt: "one day teen patti",
      name: "one day teen patti",
      providerName: "Ezugi",
    },

    UltimateRoulette: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/ezg-ultimate-roulette",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/indian-card/UltimateRoulette.jpg",
      alt: "UltimateRoulette",
      name: "Ultimate Roulette",
      providerName: "Ezugi",
    },
  },

  popularGames: {
    AviatorX: {
      code: "",
      casino: "Aviatrix",
      provider: "ALT_GAMING_GAP",
      redirectUrl: "/casino/aggapaviatrix-nft-aviatrix",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/popular/slots/AviatrixNew.webp",
      alt: "Aviatrix",
      name: "Aviatrix",
      providerName: "ALT_GAMING_GAP",
    },
    JetX: {
      code: "",
      casino: "Smartsoft Gaming",
      provider: "ALT_GAMING_GAPi",
      redirectUrl: "/casino/aggapsmartsoftgaming-jetx",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/popular/slots/JetXNew.webp",
      alt: "JetX",
      name: "JetX",
      providerName: "ALT_GAMING_GAP",
    },
    CazinoZeppelin: {
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      redirectUrl: "/casino/qt-cazino-zeppelin",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/popular/slots/ZeppelinNew.webp",
      alt: "Cazino Zeppelin",
      name: "Cazino Zeppelin",
      providerName: "WorldCasino",
    },
    CrystalClusters: {
      code: "",
      casino: "BGaming",
      provider: "ALT_GAMING_GAP",
      redirectUrl: "/casino/aggapbgaming-crystal-clusters-u9530",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/popular/slots/CrystalNew.webp",
      alt: "Crystal Clusters",
      name: "Crystal Clusters",
      providerName: "ALT_GAMING_GAP",
    },
    Dice: {
      code: "",
      casino: "Hacksaw Gaming",
      provider: "ALT_GAMING_GAP",
      redirectUrl: "/casino/aggaphacksawgaming-dice-u8285",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/popular/slots/DiceNew.webp",
      alt: "Dice",
      name: "Dice",
      providerName: "ALT_GAMING_GAP",
    },
    HiLow: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/aggappascal-hilo",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/popular/slots/Hi-LowNew.webp",
      alt: "HiLow",
      name: "HiLow",
      providerName: "ALT_GAMING_GAP",
    },
    Mines: {
      code: "",
      casino: "InOut",
      provider: "WorldCasino",
      redirectUrl: "/casino/io-mines",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/popular/slots/MinesNew.webp",
      alt: "Mines",
      name: "Mines",
      providerName: "WorldCasino",
    },
    Plinko: {
      code: "",
      casino: "InOut",
      provider: "WorldCasino",
      redirectUrl: "/casino/io-plinko-1000",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/popular/slots/PlinkoNew.webp",
      alt: "Plinko",
      name: "Plinko",
      providerName: "WorldCasino",
    },
    LimboCat: {
      code: "",
      casino: "Onlyplay",
      provider: "WorldCasino",
      redirectUrl: "/casino/gt-limbo-cat",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/popular/slots/LimboCatNew.webp",
      alt: "LimboCat",
      name: "LimboCat",
      providerName: "WorldCasino",
    },
    Solitaire: {
      code: "",
      casino: "Mac88 Gaming Virtual",
      provider: "ALT_GAMING_GAP",
      redirectUrl: "/casino/aggapmac88gamingvirtual-solitaire",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/popular/slots/SolitaireNew.webp",
      alt: "Solitaire",
      name: "Solitaire",
      providerName: "ALT_GAMING_GAP",
    },
    F777Fighter: {
      code: "",
      casino: "Onlyplayl",
      provider: "WorldCasino",
      redirectUrl: "/casino/gt-f777-fighter",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/popular/slots/F777FighterNew.webp",
      alt: "F777 Fighter",
      name: "F777 Fighter",
      providerName: "WorldCasino",
    },
    CricketX: {
      code: "",
      casino: "Onlyplayl",
      provider: "WorldCasino",
      redirectUrl: "/casino/aggapsmartsoftgaming-cricketx",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/popular/slots/cricketxNew.webp",
      alt: " CricketX",
      name: " CricketX",
      providerName: "WorldCasino",
    },
  },

  rightBarGames: {
    SuperAndarBahar: {
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      redirectUrl: "/casino/ezg-andar-bahar",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/rightbar/SuperAndarBahar.jpg",
      alt: "Super Andar Bahar",
      name: "Super Andar Bahar",
      providerName: "Super Andar Bahar",
    },
    BaccaratRB: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/ezugi/Baccarat",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/rightbar/baccarat.jpg",
      alt: "baccarat",
      name: "baccarat",
      providerName: "Ezugi",
    },
    OracleBlazeRoulette: {
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      redirectUrl: "/casino/vivo-oracle-blaze-roulette",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/rightbar/vivo-oracle-blaze-roulette.jpg",
      alt: "oracle blaze roulette",
      name: "oracle blaze roulette",
      providerName: "Vivo",
    },
    SicBoRB: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/ezg-sic-bo",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/rightbar/sic-bo.jpg",
      alt: "sic bo",
      name: "sic bo",
      providerName: "Ezugi",
    },
    SpeedRouletteRB: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/ezg-speed-roulette",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/rightbar/speed-roulette.jpg",
      alt: "speed roulette",
      name: "speed roulette",
      providerName: "Ezugi",
    },

    ItalianRouletteRB: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/ezg-italian-roulette",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/rightbar/italian-roulette.jpg",
      alt: "italian roulette",
      name: "italian roulette",
      providerName: "Ezugi",
    },

    NamasteRouletteRB: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/ezg-namaste-roulette",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/rightbar/namaste-roulette.jpg",
      alt: "namaste roulette",
      name: "namaste roulette",
      providerName: "Ezugi",
    },
    Lucky7RB: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/ezg-lucky-7",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/rightbar/lucky7.jpg",
      alt: "lucky 7",
      name: "lucky 7",
      providerName: "Ezugi",
    },
    Cards32RB: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/ezg-32-cards",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/rightbar/cards32.jpg",
      alt: "32 cards",
      name: "32 cards",
      providerName: "Ezugi",
    },
  },

  verticalSlider: {
    AviatorVS: {
      code: "",
      casino: "Spribe",
      provider: "Spribe",
      redirectUrl: "/casino/spribe/aviator",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/VSlider/aviator.jpg",
      alt: "aviator",
      name: "aviator",
      providerName: "Spribe",
    },
    OneDayTeenPattiVS: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/ezg-one-day-teen-patti",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/VSlider/one-day-teen-patti.jpg",
      alt: "one day teen patti",
      name: "one day teen patti",
      providerName: "Ezugi",
    },
    SpeedVipBlackjackAVS: {
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      redirectUrl: "/casino/ezgevo-speed-vip-blackjack-a",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/VSlider/speed-vip-blackjack-a.jpg",
      alt: "speed vip blackjack a",
      name: "speed vip blackjack a",
      providerName: "Ezugi",
    },
  },
};
